import React from 'react';
import {
  Modal,
  Button,
  Headline,
  Icon,
  designSystemToken,
  Body,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import styles from './MessageCreatorsModal.module.scss';
import {MESSAGE_MODAL_SX} from './constants';
import type {MessageCreator} from './types';

interface MessageCreatorsSuccessModalProps {
  open: boolean;
  creators: MessageCreator[];
  onDone: () => void;
}

function MessageCreatorsSuccessModal({
  open,
  creators,
  onDone,
}: MessageCreatorsSuccessModalProps) {
  const isSingle = creators.length === 1;
  const title = isSingle
    ? translate('Message sent to {name}', {name: creators[0].displayName})
    : translate('Message sent to {count} creators', {count: creators.length});

  return (
    <Modal open={open} handleClose={onDone} size="large" sx={MESSAGE_MODAL_SX}>
      <div className={styles.successContent}>
        <Icon
          appearance="neutral"
          name="Actions-Accept"
          color={designSystemToken('semantic.bg.brand')}
        />
        <Headline size="md">{title}</Headline>
        <Body size="md" color={designSystemToken('semantic.fg.secondary')}>
          {translate('Delivered via email and in-app message')}
        </Body>
        <div className={styles.doneButtonContainer}>
          <Button
            mode="filled"
            appearance="neutral"
            size="large"
            onClick={onDone}
          >
            {translate('Done')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default MessageCreatorsSuccessModal;
